import Vue from 'vue'
import Router from 'vue-router'
import { store } from '@/shared/store'

// Containers
const AppContainer = () => import('@/containers/AppContainer')

// Views
const Dashboard = () => import('@/views/Dashboard')

const CustomersList = () => import('@/views/CustomersList')
const OrdersList = () => import('@/views/OrdersList')
const DisbursesList = () => import('@/views/DisbursesList')
const ShippingsList = () => import('@/views/ShippingsList')

const DepositsHistory = () => import('@/views/deposits/DepositsHistory')
const RequestTopUpDeposit = () => import('@/views/deposits/RequestTopUpDeposit')
const TopUpDepositsList = () => import('@/views/deposits/TopUpDepositsList')

const IncentivesHistory = () => import('@/views/incentives/IncentivesHistory')
const RequestIncentive = () => import('@/views/incentives/RequestIncentive')
const RequestIncentivesList = () => import('@/views/incentives/RequestIncentivesList')

const UpdateMargin = () => import('@/views/UpdateMargin')

const Login = () => import('@/views/pages/LoginPassword')
const Page404 = () => import('@/views/pages/Page404')

Vue.use(Router)

let router = new Router({
  mode: 'history', // https://router.vuejs.org/api/#mode

  linkActiveClass: 'open active',

  scrollBehavior: () => ({ y: 0 }),

  routes: [
    {
      path: '/',
      redirect: '/dashboard',
      name: 'Home',
      component: AppContainer,
      children: [
        {
          path: 'dashboard',
          name: 'Dashboard',
          component: Dashboard
        },
        {
          path: 'customers-list',
          name: 'Customers List',
          component: CustomersList
        },
        {
          path: 'orders-list',
          name: 'Orders List',
          component: OrdersList
        },
        {
          path: 'disburses-list',
          name: 'Disburses List',
          component: DisbursesList
        },
        {
          path: 'shippings-list',
          name: 'Shippings List',
          component: ShippingsList
        },
        {
          path: 'deposits',
          redirect: '/deposits/deposits-history',
          name: 'Deposits',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'deposits-history',
              name: 'Deposits History',
              component: DepositsHistory
            },
            {
              path: 'request-deposit',
              name: 'Request Deposit',
              component: RequestTopUpDeposit
            },
            {
              path: 'request-deposits-list',
              name: 'Request Deposits List',
              component: TopUpDepositsList
            },
          ]
        },
        {
          path: 'incentives',
          redirect: '/incentives/request-incentive',
          name: 'Incentives',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'incentives-history',
              name: 'Incentives History',
              component: IncentivesHistory
            },
            {
              path: 'request-incentive',
              name: 'Request Incentive',
              component: RequestIncentive
            },
            {
              path: 'request-incentives-list',
              name: 'Request Incentives List',
              component: RequestIncentivesList
            },
          ]
        },
        {
          path: 'update-margin',
          name: 'Update Margin',
          component: UpdateMargin
        },
      ],
      meta: {
        requiresAuth: true
      }
    }, // root

    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: {
        requiresUnauth: true
      }
    },

    {
      path: "*",
      name: 'Page404',
      component: Page404
    }
  ]
})

router.beforeEach((to, from, next) => {
  // prevent multiple request
  if (store.isProcessing()) {
    return
  }

  store.hideAlert()

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (localStorage.userToken) {
      next()
      return
    } else {
      next('/login')
    }
  } else if (to.matched.some(record => record.meta.requiresUnauth)) {
    if (localStorage.userToken) {
      next('/')
      return
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router
